import { generatePath } from 'react-router-dom';

export const RoutePaths = {
    Subscriptions: {
        AllActive: {
            route: '/',
            url: (icId?: string) => RoutePaths.Subscriptions.AllActive.route + getQueryParameters({ icId }),
            title: 'Subscriptions',
        },
        Manage: {
            route: '/manage/:natureId/:groupId',
            url: (
                natureId: number,
                groupId: number,
                icId?: string,
                category?: number,
                product?: number,
                keyword?: number,
            ) => generatePath(RoutePaths.Subscriptions.Manage.route, {
                natureId: `${natureId}`,
                groupId: `${groupId}`,
            }) + getQueryParameters({ icId, category, product, keyword }),
            title: 'Manage',
        },
    },

    Errors: {
        NotAuthorized: {
            route: '/error/not-authorized',
            url: () => RoutePaths.Errors.NotAuthorized.route,
        },
        NotFound: {
            route: '*',
            url: () => '/error/not-found',
        },
    },
    History: {
        route: '/history/:page',
        url: (page: number, icId?: string) => generatePath(RoutePaths.History.route, { page: `${page}` }) + getQueryParameters({ icId }),
        title: 'History',
    },
    ThirdPartiesAccess: {
        route: '/third-parties-access',
        url: (icId?: string) => RoutePaths.ThirdPartiesAccess.route + getQueryParameters({ icId }),
        title: 'Third parties access',
    },
    ThirdPartiesHistory: {
        route: '/third-parties-history',
        url: (take: number, skip: number, icId?: string) => RoutePaths.ThirdPartiesHistory.route + getQueryParameters({ take, skip, icId }),
        title: 'Third parties history',
    },
} as const;

export type RouteParams = {
    Subscriptions: {
        AllActive: ExtractRouteParams<typeof RoutePaths.Subscriptions.AllActive.route, string>,
        Manage: ExtractRouteParams<typeof RoutePaths.Subscriptions.Manage.route, string>,
    },
    Errors: {
        NotAuthorized: ExtractRouteParams<typeof RoutePaths.Errors.NotAuthorized.route, string>,
        NotFound: ExtractRouteParams<typeof RoutePaths.Errors.NotFound.route, string>,
    },
    History: ExtractRouteParams<typeof RoutePaths.History.route, string>,
};

type ExtractRouteOptionalParam<T extends string, U = string | number | boolean> = T extends `${infer Param}?`
    ? { [_ in Param]?: U }
    : T extends `${infer Param}*`
    ? { [_ in Param]?: U }
    : T extends `${infer Param}+`
    ? { [_ in Param]: U }
    : { [_ in T]: U };

/* eslint-disable */
type ExtractRouteParams<T extends string, U = string | number | boolean> = string extends T
    ? { [_ in string]?: U }
    : T extends `${infer _}:${infer ParamWithOptionalRegExp}/${infer Rest}`
    ? ParamWithOptionalRegExp extends `${infer Param}(${infer _})`
    ? ExtractRouteOptionalParam<Param, U> & ExtractRouteParams<Rest, U>
    : ExtractRouteOptionalParam<ParamWithOptionalRegExp, U> & ExtractRouteParams<Rest, U>
    : T extends `${infer _}:${infer ParamWithOptionalRegExp}`
    ? ParamWithOptionalRegExp extends `${infer Param}(${infer _})`
    ? ExtractRouteOptionalParam<Param, U>
    : ExtractRouteOptionalParam<ParamWithOptionalRegExp, U>
    : unknown;

const cleanUrlParameter = (parameter?: string) => {
    if (!parameter) {
        return parameter;
    }

    return encodeURIComponent(parameter);
};

const getQueryParameters = (parameters: Record<string, string | number | boolean | Date | undefined | string[] | number[]>) => {
    const search = new URLSearchParams();

    for (const parametersKey in parameters) {
        const value = parameters[parametersKey];
        if (value != undefined) {
            if (Array.isArray(value)) {
                value.forEach(v => search.append(parametersKey, getQueryParameterValue(v)));
            } else {
                search.append(parametersKey, getQueryParameterValue(value));
            }
        }
    }

    const str = search.toString();
    return str ? `?${str}` : '';
};

const getQueryParameterValue = (value: string | number | boolean | Date | undefined): string => {
    if (value instanceof Date) {
        return value?.toISOString() || '';
    }
    return value?.toString() || '';
};